/**
 * Local storage implementation for selection persistence
 * Infrastructure layer - integrates with browser localStorage API
 */

import { PhotoId } from '../core/domain.js';
import { ISelectionStorage } from '../core/ports.js';

/**
 * localStorage key for selection data
 */
const SELECTION_STORAGE_KEY = 'photo_selection';

/**
 * Implementation of selection storage using localStorage
 */
export class LocalSelectionStorage implements ISelectionStorage {
  loadSelection(): Set<PhotoId> {
    try {
      const json = localStorage.getItem(SELECTION_STORAGE_KEY);
      if (!json) {
        return new Set();
      }
      const ids = JSON.parse(json) as string[];
      return new Set(ids);
    } catch (error) {
      console.error('Error loading selection from localStorage:', error);
      return new Set();
    }
  }

  saveSelection(selectedIds: Set<PhotoId>): void {
    try {
      const json = JSON.stringify([...selectedIds]);
      localStorage.setItem(SELECTION_STORAGE_KEY, json);
    } catch (error) {
      console.error('Error saving selection to localStorage:', error);
    }
  }

  clearSelection(): void {
    try {
      localStorage.removeItem(SELECTION_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing selection from localStorage:', error);
    }
  }
}
